// angular
import { Injectable } from '@angular/core';

@Injectable()
export class DocumentService {}
